import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  resources: {
    en: {
      translation: require('./locales/en/translation.json'),
    },
    de: {
      translation: require('./locales/de/translation.json'),
    },
    es: {
      translation: require('./locales/es/translation.json'),
    },
    fr: {
      translation: require('./locales/fr/translation.json'),
    },
    it: {
      translation: require('./locales/it/translation.json'),
    },
    pt: {
      translation: require('./locales/pt/translation.json'),
    },
    zu: {
      translation: require('./locales/zu/translation.json'),
    },
  },
})

export default i18n
